import { CaseStatus as CaseStatusEnum } from '@debbie/common/dist/cases/index.js';
import { sortBy } from '@debbie/common/dist/economy/helpers/utils.js';
import { useCustomerRelatedCases } from '@debbie/cortex/dist/customers-related-cases/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { styled } from 'styled-components';
import CaseStatus from '../CaseStatus.js';
import { ExternalLink } from '../Icons/index.js';
import PlaceholderLoader from '../PlaceholderLoader.js';
import Table from '../Table.js';
const orderByCaseStatus = {
    [CaseStatusEnum.PENDING]: 1,
    [CaseStatusEnum.VERIFIED]: 2,
    [CaseStatusEnum.ENDED]: 3,
};
const CasesRelatedToCustomer = (props) => {
    const lang = useSelector((s) => s.lang);
    const relatedCasesLoadable = useCustomerRelatedCases(props.customerId);
    const relatedCases = h.hasData(relatedCasesLoadable)
        ? relatedCasesLoadable.data.filter((relatedCase) => {
            if (props.userOnCustomerId) {
                return relatedCase.userOnCustomerId === props.userOnCustomerId;
            }
            return true;
        })
        : null;
    return (React.createElement("div", { style: {
            fontSize: '0.8em',
            cursor: 'default',
        }, onClick: (e) => {
            e.stopPropagation();
        } }, relatedCases ? (relatedCases.length ? (React.createElement(Table, { zebra: true },
        React.createElement("tr", null,
            React.createElement("th", null, lang.customers.caseStatus),
            React.createElement("th", null, lang.customers.relationType),
            React.createElement("th", null, lang.customers.creditor),
            React.createElement("th", { style: { width: '85px', textAlign: 'right', cursor: 'pointer' } },
                React.createElement(Link, { to: `/cases/${relatedCases
                        .map((_case) => _case.caseSeqId)
                        .join(',')}`, style: { color: 'inherit', textDecoration: 'none' } },
                    lang.customers.case,
                    " ",
                    React.createElement(ExternalLink, null)))),
        relatedCases
            .sort(sortBy((a, b) => (orderByCaseStatus[a.caseStatus] || 0) -
            (orderByCaseStatus[b.caseStatus] || 0), (a, b) => b.caseSeqId - a.caseSeqId))
            .map((relatedCase) => (React.createElement(Relation, { key: relatedCase.caseId },
            React.createElement("td", null,
                React.createElement(CaseStatus, { status: relatedCase.caseStatus, endReasonId: relatedCase.caseEndReasonId, statusTime: relatedCase.caseStatusTime })),
            React.createElement("td", null, relatedCase.relation
                .map((relation) => lang.customerCaseRelationType[relation] || relation)
                .join(', ')),
            React.createElement("td", null, relatedCase.creditorName),
            React.createElement("td", { style: { textAlign: 'right', cursor: 'pointer' } },
                React.createElement(Link, { to: `/cases/${relatedCase.caseSeqId}`, style: { color: 'inherit', textDecoration: 'none' } },
                    relatedCase.caseSeqId,
                    " ",
                    React.createElement(ExternalLink, null)))))))) : (React.createElement("h3", null, lang.customers.noRelatedCases))) : (React.createElement(PlaceholderLoader, null))));
};
export default CasesRelatedToCustomer;
const Relation = styled.tr ``;
//# sourceMappingURL=CasesRelatedToCustomer.js.map